import { ConfigServiceProvider } from '../../../core/services/config-service/config-service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SimpleVisibility } from '../../../core/model/simple-visibility.model';
import { StorageServiceProvider } from '../../../core/services/storage-service/storage-service';
import { TaskDefinition, TaskTargetGroup, TaskTargetUser } from '../../interfaces/task-definition';
import { TaskDefinitionsByTaskDefinitionId, TaskRealizationsByTaskDefinitionId } from '../../interfaces/utils';
import { User } from '../../../core/services/users-service/interfaces/user.interface';
import { UserDisplay } from '../../../core/services/users-service/interfaces/user-display.interface';

@Injectable()
export class TasksServiceProvider {
  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {
  }

  public load() {
    return new Promise((resolve, reject) => {
      this.http
          .get(this.configService.getUrl('tasks'))
          .toPromise()
          .then(
              (response) => {
                let tasksDefArray = response['taskDefinitions'] || [];
                let tasksRealizationsArray = response['taskRealizations'] || [];
                let tasksDef = {};
                let tasksRealizations = {};

                for (let i = 0; i < tasksDefArray.length; i++) {
                  tasksDef[tasksDefArray[i].id] = tasksDefArray[i];
                }

                for (let j = 0; j < tasksRealizationsArray.length; j++) {
                  tasksRealizations[tasksRealizationsArray[j].taskDefinitionId] = tasksRealizationsArray[j];
                }
                Promise.all([
                  this.storageService.setObject('tasksDefinitions', tasksDef),
                  this.storageService.setObject('tasksRealizations', tasksRealizations),
                ])
                    .then((response) => {
                      resolve(response);
                    })
                    .catch((err) => {
                      console.error(err);
                      reject(err);
                    });
              },
              (err) => {
                console.error(err);
                reject(err);
              },
          );
    });
  }

  public getTasksDef(): Promise<Map<number, TaskDefinition>> {
    return this.storageService.getObject('tasksDefinitions');
  }

  public getTasksRealizations(): Promise<TaskRealizationsByTaskDefinitionId> {
    return this.storageService.getObject('tasksRealizations');
  }

  public getFirstGroupTargetInvolvingPlayer(taskDefinition: TaskDefinition, user: User | UserDisplay): TaskTargetGroup {
    const targetsGroup = taskDefinition.params.targetsGroup;
    return targetsGroup.find((target) => this.visibilityIncludesUser(target.ids, user));
  }

  public getFirstIndividualTargetInvolvingPlayer(taskDefinition: TaskDefinition, user: User | UserDisplay): TaskTargetUser {
    const targetsList = taskDefinition.params.targetsUser;
    return targetsList.find((target) => this.visibilityIncludesUser(target.ids, user));
  }

  private visibilityIncludesUser(visibility: SimpleVisibility, user: User | UserDisplay): boolean {
    return visibility && (
        (visibility.people && visibility.people.indexOf(user.id) !== -1) ||
        (visibility.groups && visibility.groups.find((groupId) => user.userGroups.find((group) => group.id === groupId) !== undefined) !== undefined)
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/tasks-service/tasks-service.ts